<h1 mat-dialog-title class="strong">Edycja etykiety</h1>
<mat-dialog-content>
  <div [formGroup]="editForm" class="flex flex-col">
    <mat-form-field appearance="outline">
      <input matInput formControlName="tagName" [maxLength]="30" [appInputMaxLength]="30" placeholder="Etykieta" />
      <mat-hint align="end"> {{ editForm.get('tagName').value?.length || 0 }} / 30</mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [appApiCallLoading]="onSave">Zapisz</button>
  <button mat-button [appApiCallLoading]="onDelete">Usuń</button>
  <button mat-button (click)="cancel()">Anuluj</button>
</mat-dialog-actions>
